module.exports = __webpack_public_path__ + "static/media/fondo_coti.9d023472.png";